import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { fetchAuthSession, fetchUserAttributes, signInWithRedirect } from 'aws-amplify/auth';
import { JwtHelperService } from "@auth0/angular-jwt";
import { from } from 'rxjs';
import { ServiceRequestService } from '../service-request.service';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

  myVariable: any;
  //tokenFromBE: string;
  //emailFromBE: string;
  //isLoggedInFromBE: string;

  constructor(public _requestService: ServiceRequestService) { 
   
  }

  /*public async getInfoFromBE(uEmail: string, uToken: string)
  {
    await this._requestService.getLoginToken(uEmail, uToken).subscribe(data => {
  
      console.log("RET TOKEN DATA = ", data)
      this.tokenFromBE = data['body']['token']
      this.emailFromBE = data['body']['email']
      this.isLoggedInFromBE = data['body']['isLoggedIn']
    })

    console.log("TOKEN ", this.tokenFromBE)
    console.log("EMAIL FROM LOGIN = ", this.emailFromBE)
    console.log("LOGINFROMBE = ", this.isLoggedInFromBE)
 
  }*/

  public isAuthenticated(): Promise<boolean> {
    return this.retrieveIdToken()
      .then(token => {
        // console.log(token);
        const helper = new JwtHelperService();
       
             let tokenId = token.toString();
             console.log('setting-uptoken');
             localStorage.setItem('token', tokenId);
             console.log('tokenSet!');
            if(token !== null && !helper.isTokenExpired(tokenId))
            {
              
              return true;
              
            }
          
      })
      .catch( async (err) => {
       
        console.log("ERROR =", err)
        await signInWithRedirect()
        return false;
      });
  }

  async retrieveIdToken(){
    return await fetchAuthSession()
        .then(data => {
          if (data.tokens && data.tokens.idToken){
            return data.tokens.idToken.toString();
          }
          else{
            return{message: "Session Invalid."};
          }
        })
        .catch(err => { return {message: "Session Invalid."};
        })
  }

  isVerified(){
    return from(fetchUserAttributes());
  }

}
